import http from '@/network/http';

export const widgetApi = {
  getConfig: () => http.get('/users/me/widget-config'),
  saveConfig: (config: unknown) => http.put('/users/me/widget-config', { widgetConfig: config }),

  // Default widget layout templates
  getMyTemplate: () => http.get('/widget-layout-templates/mine'),
  getTemplates: () => http.get('/widget-layout-templates/admin/all'),
  upsertTemplate: (targetType: string, targetCode: string, config: unknown, overrideExisting = false) =>
    http.put(`/widget-layout-templates/admin/${targetType}/${targetCode}`, { config, overrideExisting }),
  deleteTemplate: (targetType: string, targetCode: string) =>
    http.delete(`/widget-layout-templates/admin/${targetType}/${targetCode}`),
};
